import PropTypes from 'prop-types'
import { CharBar } from './ChartBar/ChartBar'

export const ChartCommon = ({ chartID, bgColor = 'bg-light' }) => {
	return (
		<div className="chart-common-wrapper">
			<CharBar chartID={chartID} bgColor={bgColor} />
		</div>
	)
}

ChartCommon.propTypes = {
	chartID: PropTypes.string,
	bgColor: PropTypes.string,
}
